import { PageLayoutStateContext } from '../../contexts/PageLayoutContext';

import type { PropsWithChildren } from 'react';
import type { PageLayoutType } from './types';

interface PageLayoutProviderProps extends PropsWithChildren {
  layoutType: PageLayoutType;
}

export default function PageLayoutProvider({ layoutType, children }: PageLayoutProviderProps) {
  return (
    <PageLayoutStateContext.Provider value={{ layoutType }}>
      {children}
    </PageLayoutStateContext.Provider>
  );
}
